
export enum SyncJobStatus { // a null status indicates there is no such job.
  PROCESSING = "PROCESSING",
  PENDING = "PENDING",
  TERMINATED_WITH_ERROR = "TERMINATED_WITH_ERROR",
  COMPLETED = "COMPLETED",
  DISCONNECTED = "DISCONNECTED",
}
